import { Text } from '@chakra-ui/react';
import { AngularNavLink } from '@texas/components/shared/AngularNavLink';
import { ReactElement } from 'react';

interface GlobalNavigationItemProps {
  active: boolean;
  icon: ReactElement;
  label: string;
  navobj?: Record<string, unknown>;
  route: string;
}

export function GlobalNavigationItem({
  active,
  icon,
  label,
  navobj,
  route,
}: GlobalNavigationItemProps) {
  return (
    <AngularNavLink
      to={route}
      navobj={navobj}
      aria-current={active ? 'page' : undefined}
      variant={active ? 'globalNavigationActive' : 'globalNavigation'}
    >
      {icon}
      <Text fontSize="12px" lineHeight="14px" noOfLines={1}>
        {label}
      </Text>
    </AngularNavLink>
  );
}

interface GlobalUtilityNavigationItemProps
  extends Omit<GlobalNavigationItemProps, 'icon'> {
  icon: ReactElement;
}

export function GlobalUtilityNavigationItem({
  active,
  icon,
  label,
  navobj,
  route,
}: GlobalUtilityNavigationItemProps) {
  return (
    <AngularNavLink
      to={route}
      navobj={navobj}
      aria-current={active ? 'page' : undefined}
      variant={
        active ? 'globalNavigationUtilityActive' : 'globalNavigationUtility'
      }
    >
      {icon}
      <Text fontSize="11px" lineHeight="13px" noOfLines={1}>
        {label}
      </Text>
    </AngularNavLink>
  );
}
